$(function () {
    const tabsBlock = $('.tabs-block');
    const tabsSelect = $('.tabs-select');
    const tabs = $(tabsBlock).find('.tab');
    const tabContent = $('.contents-table').find('.tab-content');

    $(tabsBlock)
        .find('.tab')
        .on('click', function (e) {
            e.preventDefault();
            const target = $(this).attr('href');
            $(tabs).removeClass('current');
            $(this).addClass('current');
            $(tabContent).hide();
            $(target).fadeIn('fast');
        });

    $(tabsSelect).on('change', function (e) {
        e.preventDefault();
        const target = $(this).val();
        $(tabs).removeClass('current');
        $(this).addClass('current');
        $(tabContent).hide();
        $(target).fadeIn('fast');
    });
});
